import { FC, memo } from 'react'

import { Button, IconButton } from 'ui/components/Buttons'
import { IconName } from 'ui/components/Icon'

import { FooterProps } from './Footer.types'

import { s } from './styles'

export const Footer: FC<FooterProps> = memo((props) => {
  const { hasChosenItems, onDeleteSARs, onXMLGenerate } = props

  return (
    <s.Box>
      <div>
        {hasChosenItems && (
          <IconButton face="negative" icon={IconName.DELETE} onClick={onDeleteSARs} data-qa="Delete">
            Remove SARs
          </IconButton>
        )}
      </div>
      {hasChosenItems && (
        <Button face="primary" onClick={onXMLGenerate}>
          Generate SAR Batch XML
        </Button>
      )}
    </s.Box>
  )
})
